// Apollo
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/link-context';

// Firebase
import firebase from '../firebase';

export default () => {
  const httpLink = new HttpLink({
    uri: process.env.GRAPHQL_ENDPOINT,
  });
  const authLink = setContext(async (_, { headers }) => {
    let token = null;
    try {
      token = await firebase.auth().currentUser.getIdToken(true);
    } catch (e) {
      // console.error(e);
    }

    return {
      headers: {
        ...headers,
        authorization: token ? token : '',
      },
    };
  });
  const cache = new InMemoryCache();

  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache,
  });

  return client;
};
